import { Instagram, Mail, MapPin, Clock, Phone } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { useNavigate } from "react-router-dom";

export const Footer = () => {
  const settings = useSettings();
  const c = settings?.contact || {};
  const navigate = useNavigate();

  return (
    <footer data-testid="site-footer" className="bg-ink text-cream/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <h3 className="font-serif text-3xl text-cream leading-none">Yocaira Abreu</h3>
          <p className="overline-label mt-1">Photography</p>
          <p className="mt-5 text-sm leading-relaxed text-cream/60 max-w-xs">
            Capturamos momentos que vivirán para siempre. Fotografía elegante, femenina y llena de emoción.
          </p>
        </div>

        <div>
          <p className="overline-label mb-5">Contacto</p>
          <ul className="space-y-3 text-sm">
            {c.phone && (
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-gold" />
                <a href={`tel:${c.phone.replace(/[^\d+]/g, "")}`} className="hover:text-gold transition-colors">{c.phone}</a>
              </li>
            )}
            {c.email && (
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-gold" />
                <a href={`mailto:${c.email}`} className="hover:text-gold transition-colors">{c.email}</a>
              </li>
            )}
            {c.instagram && (
              <li className="flex items-center gap-3">
                <Instagram size={16} className="text-gold" />
                <a href={`https://instagram.com/${c.instagram}`} target="_blank" rel="noreferrer" className="hover:text-gold transition-colors">@{c.instagram}</a>
              </li>
            )}
            {c.address && (
              <li className="flex items-center gap-3">
                <MapPin size={16} className="text-gold" /> {c.address}
              </li>
            )}
            {c.service_area && (
              <li className="flex items-center gap-3">
                <MapPin size={16} className="text-gold" /> {c.service_area}
              </li>
            )}
            {c.hours && (
              <li className="flex items-center gap-3">
                <Clock size={16} className="text-gold" /> {c.hours}
              </li>
            )}
          </ul>
        </div>

        <div>
          <p className="overline-label mb-5">Explora</p>
          <ul className="space-y-3 text-sm">
            {["Portafolio", "Servicios", "Paquetes", "Sobre mí", "Contacto"].map((t, i) => (
              <li key={t}>
                <button
                  onClick={() => {
                    const map = ["#portafolio", "#servicios", "#paquetes", "#sobre-mi", "#contacto"];
                    document.querySelector(map[i])?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="hover:text-gold transition-colors"
                >
                  {t}
                </button>
              </li>
            ))}
            <li>
              <button onClick={() => navigate("/reservar")} className="hover:text-gold transition-colors">Reservar</button>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-cream/50">
          <p>© {new Date().getFullYear()} Yocaira Abreu Photography. Todos los derechos reservados.</p>
          <button data-testid="footer-admin-link" onClick={() => navigate("/admin")} className="hover:text-gold transition-colors font-mono">
            Panel administrativo
          </button>
        </div>
      </div>
    </footer>
  );
};
